import React from "react";
import { SUBTASK_TYPE } from "./ProjectConfigurationTypes";
import { CONTENT_STATUS_CONFIG } from "./projectConfigConstants";
import { ContentStatus } from "./SubtaskComponent";

interface ContentStatusIndicatorProps {
  contentId: string;
  contentType: typeof SUBTASK_TYPE[keyof typeof SUBTASK_TYPE];
  contentStatus?: ContentStatus | null;
}

/**
 * Content Status Indicator Component
 * Displays colored circles for content status (Assigned=Red, Uploaded=Yellow, Approved=Green)
 */
const ContentStatusIndicator: React.FC<ContentStatusIndicatorProps> = ({
  contentId,
  contentType,
  contentStatus
}) => {
  if (!contentStatus) return null;
  
  const typeStatus = contentStatus[contentType];
  if (!typeStatus) return null;
  
  const normalizedContentId = String(contentId).trim();
  
  const activeStatuses = CONTENT_STATUS_CONFIG.filter(status => 
    typeStatus[status.key as keyof typeof typeStatus]?.some(
      id => String(id).trim() === normalizedContentId
    )
  );
  
  if (activeStatuses.length === 0) return null;
  
  return (
    <div className="d-flex align-items-center justify-content-center gap-1 ms-2" style={{ alignSelf: "center" }}>
      {activeStatuses.map(status => (
        <span
          key={status.key}
          title={status.title}
          style={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            backgroundColor: status.color,
            display: "inline-block",
            flexShrink: 0,
            verticalAlign: "middle"
          }}
        />
      ))}
    </div>
  );
};

export default ContentStatusIndicator;
